export default __webpack_public_path__ + "4594b7b822939bf572b1e22314ac2a16.png";